import styled from "styled-components";
import { Table } from "antd";

export const ClearTable = styled(Table)`
&&.historicalNAVTable {
  .ant-table-tbody > tr > td{
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
}
  @media only screen and (max-width: 576px) {
    .ant-table-tbody > tr > td {
      background-color: ${props => props.theme.backgroundColor.layoutLight} !important;
      border: none;
    }
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 7px 16px;
    }
  }
`;
